// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorBoundary_wrapper__VcjIi","message":"ErrorBoundary_message__unHx4","reloadButton":"ErrorBoundary_reloadButton__Y0ND2"};